import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Flatpickr from 'react-flatpickr';
import BreadCrumb from "Common/BreadCrumb";
import Select, { SelectInstance } from 'react-select';
import "flatpickr/dist/flatpickr.css";

// Icon
import { Loader2, Trash2, UploadCloud } from 'lucide-react';

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

// Image
import Dropzone from "react-dropzone";
import {
    addCompany,
    getCities,
    getCompany,
    getDistricts,
    getStates,
    updateCompany,
    uploadCategoryImage,
    uploadCompanyImage
} from "helpers/backend_helper";
import { Common } from "helpers/common";
import { ToastContainer } from "react-toastify";
import { CompanyType } from "types/CompanyTypes";
import { RegionType } from "types/RegionType";
import { IMAGE_FOLDER } from "constants/settings";

export type AttributesOption = {
    readonly value: string
    readonly label: string
}
export const ManageCompany = () => {
    const [companyData, setcompanyData] = useState<CompanyType>();
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const commonHelper = new Common();
    const [states, setStates] = useState<RegionType[]>([]);
    const [districts, setDistricts] = useState<RegionType[]>([]);
    const [cities, setCities] = useState<RegionType[]>([]);
    const [selectedState, setSelectedState] = useState<any>();
    const [selectedCity, setSelectedCity] = useState<any>();
    const [selectedDistrict, setSelectedDistrict] = useState<any>();
    const [selectedFiles, setSelectedFiles] = React.useState<any>([])
    const [selectedImage, setSelectedImage] = useState<any>();
    const districtRef = useRef<SelectInstance<RegionType> | null>(null)
    const cityRef = useRef<SelectInstance<RegionType> | null>(null)
    const [isEdit, setIsEdit] = useState<boolean>(false);


    const handleAcceptedFiles = (files: any) => {
        files.map((file: any) =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                formattedSize: commonHelper.formatBytes(file.size),
            })
        )
        setSelectedFiles(files)
        setSelectedImage(files[0]);
        validation.setFieldValue('logo', 'htttp://sample.com');
    }


    useEffect(() => {
        loadCompany();
    }, [])

    useEffect(() => {
        if (companyData?.id) {
            setIsEdit(companyData?.id > 0);
            let obj = {
                preview: companyData.businessLogo,
                formattedSize: '',
                name: ''
            }
            setSelectedFiles((prev: any) => [{ ...obj }]);
            loadStates();

        }

    }, [companyData?.id])


    const loadCompany = async () => {

        let response = await getCompany();
        console.log('company', response)
        if (response.data) {
            setcompanyData(response.data[0] as CompanyType);
        }

    }
    const loadStates = async () => {
        if (states.length === 0) {

            let response = await getStates();
            console.log('states', response)

            if (response.success) {
                const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
                setStates(items);
                if (companyData?.stateId) {
                    setSelectedState(items?.find(i => i.value == companyData?.stateId));
                }
            }

            if (companyData?.id) {
                await loadDistrict(companyData.stateId);
                await loadCities(companyData.districtId);
            }
        }
    }
    const loadDistrict = async (stateId: number) => {
        if (!stateId)
            return;

        var params = 'value=' + stateId;
        console.log(params);
        try {
            let response = await getDistricts(params)
            console.log('districts', response)

            if (response.success) {
                const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
                setDistricts(items);
                if (companyData?.districtId) {
                    setSelectedDistrict(items?.find(i => i.value == companyData?.districtId));
                }
            }
        } catch (err) {
            console.log(err);
            commonHelper.showErrorMessage('No district found for selected state.')
        }
    }

    const loadCities = async (districtId: number) => {
        if (!districtId)
            return;

        var params = 'value=' + districtId;
        try {

            let response = await getCities(params)
            console.log('cities', response)

            if (response.success) {
                const items = [{ value: '', label: 'Select' }, ...(response.data as any[]).map(item => ({ value: item.id, label: item.name }))]
                setCities(items);
                if (companyData?.cityId) {
                    setSelectedCity(items?.find(i => i.value == companyData?.cityId));
                }
            }
        } catch (err) {
            console.log(err);
            commonHelper.showErrorMessage('No city found for selected district.')
        }
    }

    const handleStateSelection = async (item: any) => {
        districtRef?.current?.clearValue();
        setSelectedState(item);
        setDistricts([]);
        setSelectedDistrict({});
        validation.setFieldValue(
            'stateId',
            item.value
        );

        loadDistrict(item.value)
    }

    const handleDistrictSelection = async (item: any) => {
        if (item) {
            cityRef?.current?.clearValue();
            setSelectedDistrict(item);
            setSelectedCity({} as RegionType);
            setCities([]);
            validation.setFieldValue(
                'districtId',
                item.value
            )
            loadCities(item.value);
        }
    }

    const handleCitySelection = (item: any) => {
        setSelectedCity(item);

        if (item) {
            console.log('selected state', item.value)
            validation.setFieldValue('cityId', item.value);
        }
    }

    // validation
    const validation: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: (companyData && companyData.name) || '',
            gstNo: (companyData && companyData.gstNo) || '',
            ownerName: (companyData && companyData.ownerName) || '',
            foundedYear: (companyData && companyData.foundedYear) || 0,
            businessType: (companyData && companyData.businessType) || '',
            addressLine1: (companyData && companyData.addressLine1) || '',
            addressLine2: (companyData && companyData.addressLine2) || '',
            landmark: (companyData && companyData.landmark) || '',
            stateId: (companyData && companyData.stateId) || 0,
            districtId: (companyData && companyData.districtId) || 0,
            cityId: (companyData && companyData.cityId) || 0,
            cityName: (companyData && companyData.cityName) || '',
            countryId: (companyData && companyData.countryId) || 0,
            pinCode: (companyData && companyData.pinCode) || '',
            businessLogo: (companyData && companyData.businessLogo) || '',
            businessDescription: (companyData && companyData.businessDescription) || '',
            businessTagLine: (companyData && companyData.businessTagLine) || '',
            contactPerson: (companyData && companyData.contactPerson) || '',
            contactPhone: (companyData && companyData.contactPhone) || '',
            contactEmail: (companyData && companyData.contactEmail) || '',
            website: (companyData && companyData.website) || '',
            pan: (companyData && companyData.pan) || '',
        },
        validationSchema: Yup.object({
            name: Yup.string().max(100).required("Please enter company name !").nullable().default(companyData?.name || ''),
            gstNo: Yup.string().max(20).required("Please enter GST number !").nullable().default(companyData?.gstNo || ''),
            ownerName: Yup.string().max(50).required("Please enter owner name !").nullable().default(companyData?.ownerName || ''),
            foundedYear: Yup.number().min(1950).max(2025).required("Please select founded year !").nullable().default(companyData?.foundedYear || 0),
            businessType: Yup.string().required("Please select business type !").nullable().default(companyData?.businessType || ''),
            addressLine1: Yup.string().max(100).required("Please enter address line 1 !").nullable().default(companyData?.addressLine1 || ''),
            addressLine2: Yup.string().max(100).nullable().default(companyData?.addressLine2 || ''),
            landmark: Yup.string().max(100).nullable().default(companyData?.landmark || ''),
            stateId: Yup.number().required("Please select state !").nullable().default(companyData?.stateId || 0),
            districtId: Yup.number().required("Please select district !").nullable().default(companyData?.districtId || 0),
            cityId: Yup.number().required("Please select city !").nullable().default(companyData?.cityId || 0),
            cityName: Yup.string().nullable().default(companyData?.cityName || ''),
            countryId: Yup.number().required("Please select country !").nullable().default(companyData?.countryId || 0),
            pinCode: Yup.number().min(100000).max(999999).required("Please enter pin code !").nullable().default(companyData?.pinCode || 0),
            businessLogo: Yup.string().nullable().default(companyData?.businessLogo || ''),
            businessDescription: Yup.string().nullable().default(companyData?.businessDescription || ''),
            businessTagLine: Yup.string().nullable().default(companyData?.businessTagLine || ''),
            contactPerson: Yup.string().required("Please enter contact person !").nullable().default(companyData?.contactPerson || ''),
            contactPhone: Yup.number().required("Please enter contact phone !").nullable().default(companyData?.contactPhone || 0),
            contactEmail: Yup.string().email().required("Please enter contact email !").nullable().default(companyData?.contactEmail || ''),
            website: Yup.string().url().nullable().default(companyData?.website || ''),
            pan: Yup.string().max(20).required("Please enter PAN number !").nullable().default(companyData?.pan || ''),
        }),

        onSubmit: async (values: any) => {

            let logo = null;

            setIsSaving(true);
            console.log('onsubmit', values)


            // upload if any new images is selected..
            if (selectedImage?.name) {
                var imgResult = await uploadCompanyImage({ fileCollection: selectedImage },IMAGE_FOLDER);
                console.log(imgResult);
                logo = imgResult?.data.rows[0].url;
            }

            let dataToSave = {
                ...values,
                businessLogo: logo ?? values.businessLogo
            };

            try {
                if (companyData) {
                    dataToSave = { ...dataToSave, id: companyData.id }
                }

                var result = await (isEdit ? updateCompany(dataToSave) : addCompany(dataToSave));
                console.log(result.data)

                commonHelper.showSuccessMessage(`Company details has been successfully saved.`);
                setIsSaving(false);

            } catch (error) {
                console.log('API-Error', error);
                commonHelper.showErrorMessage(error as string);
                setIsSaving(false);
            }
        },

    });
    return (
        <React.Fragment>
            <ToastContainer closeButton={false} limit={1} />
            <form action="#!" onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
            }}>
                <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5" style={{ marginTop: 10 }} >
                    <div className="xl:col-span-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="grid grid-cols-1 gap-5 lg:grid-cols-2 xl:grid-cols-12">
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="name" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.name && validation.errors.name ? 'text-red-500' : ''}`}>Company Name</label>
                                        <input type="text" id="name"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.name || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Company name" />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="gstNo" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.gstNo && validation.errors.gstNo ? 'text-red-500' : ''}`}>GST Number</label>
                                        <input type="text" id="gstNo"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="GST number"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.gstNo || ""}
                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="pan" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.pan && validation.errors.pan ? 'text-red-500' : ''}`}>PAN Number</label>
                                        <input type="text" id="pan"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="PAN number"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.pan || ""}
                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="ownerName" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.ownerName && validation.errors.ownerName ? 'text-red-500' : ''}`}>Owner Name</label>
                                        <input type="text" id="ownerName"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.ownerName || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Owner name" />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="foundedYear" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.foundedYear && validation.errors.foundedYear ? 'text-red-500' : ''}`}>Founded Year</label>
                                        <input type="text" id="foundedYear"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Founded year"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.foundedYear}
                                        />
                                        {validation.errors.foundedYear}
                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="businessType" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.businessType && validation.errors.businessType ? 'text-red-500' : ''}`}>Business Type</label>
                                        <input type="text" id="businessType"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.businessType || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business type" />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="addressLine1" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.addressLine1 && validation.errors.addressLine1 ? 'text-red-500' : ''}`}>Address Line 1</label>
                                        <input type="text" id="addressLine1"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Address line 1"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.addressLine1 || ""}
                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="addressLine2" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.addressLine2 && validation.errors.addressLine2 ? 'text-red-500' : ''}`}>Address Line 2</label>
                                        <input type="text" id="addressLine2"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.addressLine2 || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Address line 2" />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="landmark" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.landmark && validation.errors.landmark ? 'text-red-500' : ''}`}>Landmark</label>
                                        <input type="text" id="landmark"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Landmark"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.landmark || ""}
                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="stateId" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.stateId && validation.errors.stateId ? 'text-red-500' : ''}`}>State</label>
                                        <Select
                                            className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                            defaultValue={selectedState}
                                            options={states}
                                            isSearchable={true} // To disable search
                                            name="stateId"
                                            id="stateId"
                                            value={selectedState}
                                            onChange={e => { handleStateSelection(e) }}
                                        />
                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="districtId" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.districtId && validation.errors.districtId ? 'text-red-500' : ''}`}>District</label>
                                        <Select
                                            className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                            options={districts}
                                            ref={districtRef}
                                            isSearchable={true} // To disable search
                                            name="districtId"
                                            id="districtId"
                                            value={selectedDistrict}
                                            onChange={e => { handleDistrictSelection(e) }}
                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="cityId" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.cityId && validation.errors.cityId ? 'text-red-500' : ''}`}>City</label>
                                        <Select
                                            className="border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                                            options={cities}
                                            ref={cityRef}
                                            isSearchable={true} // To disable search
                                            name="cityId"
                                            id="cityId"
                                            value={selectedCity}
                                            onChange={e => { handleCitySelection(e) }}
                                        />
                                    </div>

                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="pinCode" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.name && validation.errors.name ? 'text-red-500' : ''}`}>Pin Code</label>
                                        <input type="phone" id="pinCode"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Pin code"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.pinCode || ""}
                                            maxLength={7}
                                        />
                                    </div>
                                    {/* <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="businessLogo" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.businessLogo && validation.errors.businessLogo ? 'text-red-500' : ''}`}>Business Logo</label>
                                        <input type="text" id="businessLogo"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.businessLogo || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business logo"

                                        />

                                    </div> */}
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="businessDescription" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.businessDescription && validation.errors.businessDescription ? 'text-red-500' : ''}`}>Business Description</label>
                                        <input id="businessDescription"
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business description"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.businessDescription || ""}
                                            maxLength={100}

                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="businessTagLine" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.businessTagLine && validation.errors.businessTagLine ? 'text-red-500' : ''}`}>Business Tag Line</label>
                                        <input type="text" id="businessTagLine"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.businessTagLine || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business tag line"
                                            maxLength={50}

                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="contactPerson" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.contactPerson && validation.errors.contactPerson ? 'text-red-500' : ''}`}>Contact Person</label>
                                        <input type="text" id="contactPerson"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.contactPerson || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business tag line"
                                            maxLength={50}

                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="contactPhone" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.contactPhone && validation.errors.contactPhone ? 'text-red-500' : ''}`}>Contact Phone</label>
                                        <input type="phone" id="contactPhone"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.contactPhone || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business tag line"
                                            maxLength={100}

                                        />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="contactEmail" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.contactEmail && validation.errors.contactEmail ? 'text-red-500' : ''}`}>Contact Email</label>
                                        <input type="email" id="contactEmail"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.contactEmail || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business tag line" />

                                    </div>
                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        <label htmlFor="website" className={`inline-block text-base font-medium text-slate-500 ${validation.touched.website && validation.errors.website ? 'text-red-500' : ''}`}>Website (https://mycompany.com)</label>
                                        <input type="url" id="website"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.website || ""}
                                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Business tag line" />

                                    </div>

                                    <div className="xl:col-span-3 md:col-span-3 ">
                                        <label htmlFor="isActive" className="inline-block mb-2 text-base font-medium">Business Logo</label> <br></br>

                                        <div className="flex items-center justify-center bg-white border border-dashed rounded-md cursor-pointer  border-slate-300 dark:bg-zink-700 dark:border-zink-500">
                                            <Dropzone
                                                onDrop={(acceptedFiles: any) => {
                                                    handleAcceptedFiles(acceptedFiles)
                                                }}
                                            >
                                                {({ getRootProps, getInputProps }: any) => (
                                                    <div
                                                        className="w-full py-5 text-lg text-center dz-message needsclick"
                                                        {...getRootProps()}
                                                    >
                                                        <input {...getInputProps()} />
                                                        <div className="mb-3">
                                                            <UploadCloud className="block size-12 mx-auto text-slate-500 fill-slate-200 dark:text-zink-200 dark:fill-zink-500"></UploadCloud>
                                                        </div>

                                                        <h5 className="mb-0 font-normal text-slate-500 text-15">Drag and drop company logo or <a href="#!">browse</a></h5>
                                                    </div>
                                                )}
                                            </Dropzone>
                                            <ul className="flex flex-wrap mb-0 gap-x-5" id="dropzone-preview2">
                                                {
                                                    (selectedFiles || [])?.map((f: any, i: any) => {
                                                        return (
                                                            <li className="mt-2" id="dropzone-preview-list" key={i + "-file"}>
                                                                <div className="border rounded border-slate-200 dark:border-zink-500">
                                                                    <div className="p-2 text-center">
                                                                        <div>
                                                                            <div style={{ height: "100px", width: "100px" }}>
                                                                                <img data-dz-thumbnail className="block w-full h-full rounded-md" src={f.preview} alt={f.name}


                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {/* <div className="pt-3">
                                                                                                <h5 className="mb-1 text-15" data-dz-name>{f.name}</h5>
                                                                                                <p className="mb-0 text-slate-500 dark:text-zink-200" data-dz-size>{f.formattedSize}</p>
                                                                                            </div> */}
                                                                        <div className="mt-2">
                                                                            <button data-dz-remove
                                                                                className="px-2 py-1.5 text-xs text-white bg-red-500 border-red-500 btn hover:text-white hover:bg-red-600 hover:border-red-600 focus:text-white focus:bg-red-600 focus:border-red-600 focus:ring focus:ring-red-100 active:text-white active:bg-red-600 active:border-red-600 active:ring active:ring-red-100 dark:ring-custom-400/20"
                                                                                onClick={() => {
                                                                                    const newImages = [...selectedFiles];
                                                                                    newImages.splice(i, 1);
                                                                                    setSelectedFiles(newImages);
                                                                                }}
                                                                            >Delete</button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>

                                        </div>


                                        <input type="hidden" id="logo" name="logo" />
                                        {validation.touched.logo && validation.errors.logo ? (
                                            <div id="logo-error" className="mt-1 text-sm text-red-500">{validation.errors.logo}</div>
                                        ) : null}
                                    </div>

                                    <div className="xl:col-span-3 md:col-span-3  ">
                                        {!isSaving ?
                                            <button type="submit" className="text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                                                style={{ height: 37, width: 100, marginTop: 20 }}
                                            >
                                                {"Save"}
                                            </button>
                                            : <button type="button" style={{ height: 37, width: 100, marginTop: 20 }} disabled className="flex items-center text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20">
                                                <Loader2 className="size-4 ltr:mr-2 rtl:ml-2 animate-spin" />
                                                Saving...
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </form>
        </React.Fragment>
    );

}